import { render, staticRenderFns } from "./Parceria_Seferj.vue?vue&type=template&id=25a472da"
import script from "./Parceria_Seferj.vue?vue&type=script&lang=js"
export * from "./Parceria_Seferj.vue?vue&type=script&lang=js"
import style0 from "./Parceria_Seferj.vue?vue&type=style&index=0&id=25a472da&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports